import Consts from "./Consts";
const url = Consts.TEST ? "http://localhost:8082/ezkay-api": "https://ezkay.vinroyaltech.com/new-api";
export const call_web_service = async (module, service, params) => {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      module,
      service,
      params,
    }),
  });

  const responseJson = await response.json();
  if (!response.ok || responseJson.RESULT_CODE !== "OK") {
    throw responseJson;
  }

  return responseJson;
};
